// custom typefaces
import 'typeface-montserrat';
import 'typeface-merriweather';
import './src/styles/button.css';

export const onRouteUpdate = ({location}) => {
  if (location.hostname === 'localhost') {
    return;
  }

  const request = new XMLHttpRequest();
  const url = 'https://blue.kroepfl.io/view?url=' + window.decodeURI(location.href);

  request.open('POST', url);
  request.send();
};
